define('LNRS/Components/ProductIndex',[
	"instantsearch", "jquery", "hierarchicalmenuwidget", "mustache",
	"algoliasearch", "algoliasearchhelper",
	"text!LNRS/Components/Templates/ProductIndexProductNameTemplate.html",
	"text!LNRS/Components/Templates/ProductIndexResultsTemplate.html"
], function (instantsearch, $, hierarchicalmenuwidget, mustache, algoliasearch, algoliasearchhelper, productNameTemplate, resultsTemplate) {
	'use strict';

	function ProductIndex(algoliaApiKey, algoliaIndexName, algoliaApplicationId, contextLanguage, productIndexId, productItemTemplateId, industryFacetId, productNamesFacetId,
		allIndustriesLabel, allProductNamesLabel, productNameHeaderClass, hitsPerPage, pagingId, pagingNextLabel, pagingPreviousLabel, noResultsText, learnMoreLabel, allProducts) {
		var productNameFacet = "_product_first_letter";
		var languageFacet = "_language";
		var templateFacet = "_template";
		var productNameValues = [];
		var $productNameContainer = $("#" + productNamesFacetId);
		var returnedFacetValues = [];
		var checkAvailableProductNameFacets = true;

		var client = algoliasearch(algoliaApplicationId, algoliaApiKey);
		var facetHelper = algoliasearchhelper(client, algoliaIndexName, {
			facets: [productNameFacet, languageFacet, templateFacet, '_industry_hierarchy.Industry', '_industry_hierarchy.SubIndustry'],
			facetsRefinements: {
				_language: [contextLanguage],
				_template: [productItemTemplateId]
			}
		});

		var onResultHandler = function (data) {
			if (productNameValues.length === 0) {
				initLists();
				initScroll();
			}

			if (checkAvailableProductNameFacets) {
				for (var i = 0; i < data.facets.length; i++) {
					var returnedFacet = data.facets[i];
					if (returnedFacet.name === productNameFacet) {
						returnedFacetValues = [];
						Object.keys(returnedFacet.data).map(function (key) {
							returnedFacetValues.push(key);
						});
					}
				}
			};

			checkAvailableProductNameFacets = true;
			renderFacet(productNameValues, productNameTemplate, $productNameContainer, productNameFacet, allProductNamesLabel, data);
			wireItemClickEvent($productNameContainer, productNameFacet);

			industryFilterWidget.onRenderCallback();
		};

		facetHelper.on('result', onResultHandler);
		facetHelper.search();

		var search = instantsearch({
			appId: algoliaApplicationId,
			apiKey: algoliaApiKey,
			indexName: algoliaIndexName,
			urlSync: true,
			searchParameters: {
				facets: [productNameFacet, languageFacet, templateFacet],
				facetsRefinements: {
					_language: [contextLanguage],
					_template: [productItemTemplateId]
				}
			}
		});

		var industryFilterWidget = hierarchicalmenuwidget(algoliaApplicationId, algoliaApiKey, algoliaIndexName, contextLanguage,
			search,
			2,
			allIndustriesLabel,
			"#" + industryFacetId,
			"_industry_hierarchy",
			"Industry",
			"SubIndustry",
			["_industry_hierarchy.Industry", "_industry_hierarchy.SubIndustry"],
			null,
			allProducts
		);

		search.addWidget(
			industryFilterWidget.widget
		);

		search.addWidget(
			instantsearch.widgets.hits({
				container: "#" + productIndexId,
				templates: {
					allItems: resultsTemplate,
					empty: "<div class='no-results'>" + noResultsText + "</div>"
				},
				transformData: {
					allItems: function (result) {

						$.each(result.hits, function (index, item) {
							item.learnMoreLabel = learnMoreLabel;
						});

						return result;
					}
				},
				hitsPerPage: hitsPerPage
			})
		);

		var w = window.innerWidth;

		var paginationWidget = instantsearch.widgets.pagination({
			container: '#' + pagingId,
			showFirstLast: false,
			padding: w < 768 ? 1 : 3,
			labels: {
				next: pagingNextLabel,
				previous: pagingPreviousLabel
			},
			cssClasses: { root: "pagination" }
		});

		var container = $('#' + pagingId);
		var oldRender = paginationWidget.render;
		paginationWidget.render = function (params) {
			var currentState = params.results;

			oldRender.call(this, params);
			if (currentState.nbPages <= 1)
				container.hide();
			else {
				container.show();
			}
		};

		search.addWidget(paginationWidget);

		var onRenderHandler = function () {
			facetHelper.clearRefinements("_industry_hierarchy.Industry");
			facetHelper.clearRefinements("_industry_hierarchy.SubIndustry");

			Object.keys(search.helper.state.hierarchicalFacetsRefinements).map(function (key) {
				if (search.helper.state.hierarchicalFacetsRefinements[key].length) {

					if (search.helper.state.hierarchicalFacetsRefinements[key]['0'].includes('>')) {
						facetHelper.toggleFacetRefinement("_industry_hierarchy.SubIndustry", search.helper.state.hierarchicalFacetsRefinements[key]);
					}
					else { facetHelper.toggleFacetRefinement(key, search.helper.state.hierarchicalFacetsRefinements[key]); }
				};
			});

			facetHelper.search();
		};

		search.on('render', onRenderHandler);
		search.start();

		function cancelBubble(e) {
			var evt = e ? e : window.event;
			if (evt.stopPropagation) evt.stopPropagation();
			if (evt.cancelBubble != null) evt.cancelBubble = true;
		};

		function wireItemClickEvent($container, facetName) {
			$($container.find("li")).on("click", function (e) {
				cancelBubble(e);

				var disabled = $(this).hasClass("disabled");

				if (disabled) {
					return false;
				}

				var itemName = $(this).data("facetname");
				var skip = $(this).data("skip") || false;

				search.helper.clearRefinements(facetName);
				facetHelper.clearRefinements(facetName);

				if (facetName === productNameFacet) {
					search.helper.clearRefinements(productNameFacet);
					facetHelper.clearRefinements(productNameFacet);
				}

				if (!skip) {
					if (facetName === productNameFacet) {
						search.helper.toggleFacetRefinement(facetName, itemName);
						checkAvailableProductNameFacets = false;
					}
					else {
						search.helper.toggleFacetRefinement(facetName, itemName);
						facetHelper.toggleFacetRefinement(facetName, itemName);
						checkAvailableProductNameFacets = false;
					}
				}
				else {
					checkAvailableProductNameFacets = true;
				}

				search.helper.search();

				return false;
			});
		};

		function renderFacet(items, itemTemplate, $container, facetName, allLabel, data, initial) {
			var selectedFacets = search.helper.state.facetsRefinements,

				model = {
					allLabel: allLabel
				};

			$.each(items, function (index, item) {
				item.selected = $.inArray(item.name, selectedFacets[facetName]) > -1;
				item.disabled = !item.skip && ($.inArray(item.name, returnedFacetValues) === -1);
				item.displayName = item.name;
			});

			model.hits = items;

			$container.html(mustache.render(itemTemplate, model));

			$('.product-index-item').hover(
				function (e) {
					e.preventDefault();

					if ($(this).find('.product-index-item-link').length) {
						$(this).find('.product-index-item-link').show();
					}
				},
				function (e) {
					e.preventDefault();

					if ($(this).find('.product-index-item-link').length) {
						$(this).find('.product-index-item-link').hide();
					}
				});

			$('.product-index-item').on("click", function (e) {
				e.preventDefault();

				var ctaLink = $(this).children('a:first-child');

				if (ctaLink && ctaLink.length && ctaLink.prop('href')) {
					window.location = ctaLink.prop('href');
				}

				return false;
			});
		}

		var initLists = function () {
			var i = "A".charCodeAt(0),
				j = "Z".charCodeAt(0);

			for (; i <= j; ++i) {
				productNameValues.push({
					name: String.fromCharCode(i).toUpperCase()
				});
			}

			productNameValues.unshift({
				name: allProductNamesLabel,
				skip: true
			});
		};

		let initScroll = () => {
			let $container = $('.product-name-filter > div');
			let $leftArrow = $('.product-name-filter .before');
			let $rightArrow = $('.product-name-filter .after');

			$container.on('scroll', () => {
				if ($container.scrollLeft() > 0) {
					$leftArrow.show();
				} else {
					$leftArrow.hide();
				}
				if ($container.scrollLeft() > 400) {
					$rightArrow.hide();
				} else {
					$rightArrow.show();
				}
			});

			$leftArrow.on("click", () => {
				$container.animate({ scrollLeft: '-=200' }, 300);
			});
			$rightArrow.on("click", () => {
				$container.animate({ scrollLeft: '+=200' }, 300);
			});
		}
	}

	return function initProductIndex(args) {
		return args.IsPageEditorEditing === true ? null : new ProductIndex(
			args.AlgoliaApiKey,
			args.AlgoliaIndexName,
			args.AlgoliaApplicationId,
			args.ContextLanguage,
			args.ProductIndexId,
			args.ProductItemTemplateId,
			args.IndustryFacetId,
			args.ProductNamesFacetId,
			args.AllIndustriesLabel,
			args.AllProductNamesLabel,
			args.ProductNameHeaderClass,
			args.HitsPerPage,
			args.PagingId,
			args.PagingNextLabel,
			args.PagingPreviousLabel,
			args.NoResultsText,
			args.LearnMoreLabel,
			args.AllProducts);
	};
});
